import verifyValidPromotionCodeMethods from './PromotionCode.verifyValidPromotionCode'

export const PromotionCodeServices = {
  verifyValidPromotionCode: verifyValidPromotionCodeMethods
}

export * from './PromotionCode.types'
